import { render, staticRenderFns } from "./TinabaPay.vue?vue&type=template&id=208db84e&"
import script from "./TinabaPay.vue?vue&type=script&lang=ts&"
export * from "./TinabaPay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports